/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import styles from "./ProgressBar.module.scss";

export interface IProgressBarProps {
  progress: number;
  className?: string;
}

export const ProgressBar = ({
  progress,
  className,
}: IProgressBarProps): JSX.Element => {
  const progressBarStyle: React.CSSProperties = {
    width: `${progress}%`,
    borderRadius: progress < 100 ? "0 4.5px 4.5px 0" : "0",
  };

  return (
    <div className={`${styles.progressBar} ${className ? className : ""}`}>
      <div className={styles.bar} style={progressBarStyle} />
    </div>
  );
};

export default ProgressBar;
